module.exports = __webpack_public_path__ + "static/media/home-bk.1cab9fd6.png";